import React from "react";
import { Card } from "@mui/material";

import Occurrence from "./components/DashOccurrence";

function Occurrencetatus() {
  return (
    <Card sx={{ backgroundColor: "green" }}>
      <Occurrence />
    </Card>
  );
}

export default Occurrencetatus;
